import { combineReducers } from 'redux';

// Reducers
import erasureReportReducer from './ErasureReport/Single/store/erasureReportReducer';
import reportFinderReducer from "../sc-admin/ReportFinder/store/reportFinderReducer";

export const subComponents = (translations) => [
    { name: translations["erasure_reports"] || "Erasure reports", path: '/erasure-reports', permissions: ['erasure_report'] },
    { name: translations["diagnose_reports"] || "Diagnose reports", path: '/diagnose-reports', permissions: ['diagnose_report'] },
    { name: translations["verification_reports"] || "Verification reports", path: '/verification-reports', permissions: ['verification_report'] },
    { name: translations["user_reports"] || "User reports", path: '/user-reports', permissions: ['report'] },
];

export const reducers = combineReducers({
    erasureReports: erasureReportReducer,
    reportFinder: reportFinderReducer
});

